import { Controller } from "@hotwired/stimulus"

// Beta 1.0 risk-acknowledgment gate. Shown once per signed-in user: the
// `beta_disclaimer_v1_ack` preference flips to true on accept, so the modal
// is a no-op afterward (the layout only renders it while the flag is false).
//
// Deliberately NOT dismissible except via "I understand & accept" — no skip,
// no Escape, no backdrop-close — because it records acceptance of the beta's
// risk + liability terms. Modeled on onboarding_tour_controller.js.
export default class extends Controller {
  static targets = ["overlay"]

  accept() {
    // Optimistically remove the modal so the UI never feels stuck even if the
    // network write is slow/offline; the server flag makes it permanent.
    if (this.hasOverlayTarget) this.overlayTarget.hidden = true
    this.element.remove()
    fetch("/api/preferences", {
      method:  "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""
      },
      body: JSON.stringify({ preferences: { beta_disclaimer_v1_ack: true } })
    }).catch(() => {})
  }
}
